import Image from "next/image";
import React from "react";

export  default  function FlagIcon({ flag }: { flag: string }) {
	return (
		<Image
			src={`/flag/${flag}.webp`}
			alt={`${flag.toUpperCase()} flag`}
			title={`${flag.toUpperCase()} flag`}
			width={20}
			height={14}
			className="rounded-sm"
		/>
	);
}
